import { render } from "./bottomIntroduction.vue?vue&type=template&id=70d34f6e&scoped=true"
import script from "./bottomIntroduction.vue?vue&type=script&lang=js"
export * from "./bottomIntroduction.vue?vue&type=script&lang=js"

import "./bottomIntroduction.vue?vue&type=style&index=0&id=70d34f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d34f6e"]])

export default __exports__